import apiClient from "../helpers/apiHelper";


// Add this to your existing api service file
export const registerUser = async (userData) => {
  const response = await apiClient.post(`/api/auth/register`, userData);
  return response;
};

export const loginUser = async (credentials) => {
  const response = await apiClient.post(`/api/auth/login`, credentials);
  return response;
};


export const getEvents = async (page = 1, search = "", limit = 10) => {
  const response = await apiClient.get(`/api/user/events`, {
    params: { page, search, limit },
});
  return response;
};

export const getEventById = async (id) => {
  const response = await apiClient.get(`/api/user/events/${id}`);
  return response;
};

export const bookEvent = async (bookingData) => {
    const response = await apiClient.post(`/api/booking`, bookingData);
    return response;
}

export const checkoutSession = async (sessionData) => {
    const response = await apiClient.post(`/api/booking/checkout`, sessionData);
    return response;
}

export const getSeatingPlan = async () => {
  const response = await apiClient.get(`/api/seating`);
  return response;
};

export const getseatingbyId = async (id) => {
  const response = await apiClient.get(`/api/seating?id=${id}`);
  return response;
};

export const getMyBookings = async (page = 1, search = "", limit = 10) => {
  try {
    const response = await apiClient.get(`/api/booking`, {
      params: { page, search, limit },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const contactUs = async (contactData) => {
  const response = await apiClient.post(`/api/contact`, contactData);
  return response;
};

export const forgotPassword = async (emailData) => {
  const response = await apiClient.post(`/api/auth/user/forgot-password`, emailData);
  return response;
};

export const resetPassword = async (resetData) => {
  const response = await apiClient.post(`/api/auth/user/reset-password`, resetData);
  return response;
};